import { Directive, ElementRef, HostListener } from "@angular/core";
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[thousandSeparator]',
})
export class ThousandSeparatorDirective {

  constructor(private _inputEl: ElementRef, private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let rawValue = this._inputEl.nativeElement.value;

    if (rawValue === '-') return;

    let noCommas = rawValue.replace(/,/g, '');
    let numericValue = parseFloat(noCommas);

    if (isNaN(numericValue)) {
      this._inputEl.nativeElement.value = '';
      this.ngControl.control?.setValue('');
      return;
    }

    let parts = noCommas.split('.');
    let formatted = parseInt(parts[0]).toLocaleString('en-US');
    if (parts[1] !== undefined) {
      formatted += '.' + parts[1].substring(0, 2); 
    }

    this._inputEl.nativeElement.value = formatted;

    this.ngControl.control?.setValue(formatted, { emitEvent: false });
  }
}
